import Vue from 'vue'
import template from './index.pug'

// @vue/component
export default Vue.extend({
  template: template(),
  props: {
    fare: {
      type: Object,
      required: true
    }
  },
  computed: {
    title() {
      return this.$t(`prePurchaseFares.sections.${this.fare.origin_destination_type}.moreInfoTitle`)
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
})
